import React, {useEffect, useRef, useState} from "react";
import NiceModal, {antdDrawer, useModal} from "@ebay/nice-modal-react";
import {callAndReload, pp} from "../../utils";
import {RichEditorHtml} from "../../components/RichEditor";
import {Drawer, Button, Space} from "antd";

document.addEventListener('paste', (event) => {
  // Access the pasted data from the clipboard
  const clipboardData = (event.clipboardData || window.clipboardData);
  const pastedText = clipboardData.getData('text');

  // Do something with the pasted text
  console.log('Pasted text:', pastedText);
});

let InfoEditor = NiceModal.create(({ pl }) => {
  const modal = useModal();
  const [content, setContent] = useState(gon.tournament.info || '');
  const [loading, setLoading] = useState(false);

  let onSave = async () => {
    setLoading(true);
    try {
      await callAndReload({
        url: '/tournaments/' + gon.tournament.tid,
        params: {info: content},
        method: 'put',
      });
      modal.hide();
    } finally {
      setLoading(false);
    }
  }

  const onCancel = () => {
    modal.hide();
  }

  return (
    <Drawer
      {...antdDrawer(modal)}
      title="Edit General Information"
      placement="right"
      width={600}
      bodyStyle={{ padding: '24px' }}
      footer={
        <div style={{ textAlign: 'right' }}>
          <Space>
            <Button onClick={onCancel}>Cancel</Button>
            <Button type="primary" loading={loading} onClick={onSave}>
              Save
            </Button>
          </Space>
        </div>
      }
    >
      <div className="my-markdown">
        <RichEditorHtml
          value={gon.tournament.info}
          onChange={setContent}
        />
      </div>
    </Drawer>
  );
});

export default ({pl}) => <a onClick={() => NiceModal.show(InfoEditor, {})}>edit</a>;
